<template>
  <div class="confim-card">
    <div class=" hotel-card-component">
        <div class="confim-card-body lg:flex relative">
            <div class="img-container mr-8">
                <img v-if="hotel.images" :src="`http://photos.hotelbeds.com/giata/${hotel.images[0].path}`" />
                <img v-else :src="`${hotel.image}`" />
            </div>
            <div class="details-container block w-full my-1 lg:my-0">
                <div class="flex">
                    <p class="name font-bold mr-3 mt-3 md:mt-0">{{ hotel.name }}</p>
                    <hotel-category
                    class="grow-0 my-1 lg:my-4"
                    :category-code="hotel.categoryCode"
                    :style="{ minWidth: hotelCategoryMinWidth(hotel.categoryCode) }"
                    ></hotel-category>
                </div>
                <div class="flex space-x-2 my-3 lg:my-4">
                    <div class="icon-container">
                    <img src="/img/icons/maps-and-flags.svg" />
                    </div>
                    <span class="text-gray-600 font-semibold">{{ hotel.distance }} km del centro</span>
                </div>
                <div v-for="(room, index) in rooms" :key="index" class="flex space-x-2 my-4">
                    <div class="block">
                    <div class="num-rooms text-sm w-6 h-6 bg-pale-grey font-black text-center rounded-sm text-black opacity-100">
                        <!-- x{{ room.rates[0].rooms }} -->
                        x1
                    </div>
                    </div>
                    <div class="block">
                    <span>{{$tc('shared.room', 1)}} {{ room.name | capitalize }}</span><br/>
                    </div>
                    <!-- <span>{{ $t("hotel.double_standard") }}</span> -->
                </div>
            </div>
        </div>
        <div class="flex items-center gap-10 pt-5">
            <div>
                <p class="font-bold mb-3">Llegada</p>
                <p>16/11/2023</p>
                <p>salida 14:00 llegada 23:00</p>
            </div>
            <div>
                <p class="font-bold mb-3">Salida</p>
                <p>26/11/2023</p>
                <p>salida 14:00 llegada 23:00</p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import HotelCategory from "../common/HotelCategory.vue";
import { NIGHTS_SET_HOTEL } from "../../../store/nights/mutation-types";
import { mapGetters } from "vuex";
import { NIGHTS_GET_NIGHTS } from "../../../store/nights/getter-types";

export default {
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    adults: {
      type: Number
    },
    nights: {
      type: Number
    },
    destination: {
      type: String
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString().toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  components: {
    HotelCategory,
  },
  computed: {
     loading() {
      return (
        this.$store.state.nights.loading &&
        this.$store.state.nights.hotel.code === this.hotel.code
      );
    },
    rooms(){
      let arr = [];
      this.hotel.rooms.forEach(room => {
        arr.push(room);
      });
      return arr;
    }
  },
  methods: {
    hotelCategoryMinWidth(categoryCode) {
      const stars = Number(categoryCode.replace(/(LUX)|(EST)/, ""));
      return `${stars * 25}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../sass/_variables.scss";

.hotel-card-component {
  border-radius: 15px;
  padding: 1.25rem;
  background-color: white;


  @media (min-width: 768px) {
    padding: 2rem 1.5rem;
  }

  + .hotel {
    margin-top: 1.5rem;
  }

  .img-container {
    width: 100%;
    height: auto;
    border-radius: 5px;

    @media (min-width: 768px) {
      width: 360px;
      height: 150px;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }
  }

  .details-container {
    .name {
      font-size: 18px;
    }

    .icon-container {
      width: 1.25rem;
      padding-bottom: .25rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .num-rooms{
      padding: .15rem 0;
    }
  }
}
</style>
